module.exports = __webpack_public_path__ + "static/media/arrow-right-bg.a585c737.svg";